import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/*
  TextField Component
*/
export default class TextField extends Component {
  /**
   * Renders the TextField component.
   *
   * @return {string} - HTML markup for the Button component
   */
  render() {
    const { inputProps, id, placeholder, label, helperText, type, error, value, onChange = () => {} } = this.props;

    const classes = {
      ...TextField.defaultProps.classes,
      ...this.props.classes,
    };
    var formHelperText = helperText ? <span>{helperText}</span> : null;
    var formError = error ? <span>{error}</span> : null;

    return (
      <div className={classnames(classes.formControl)}>
        {label && (
          <label htmlFor={id} className={classnames(classes.inputLabel)} style={this.props.style}>
            {label}
          </label>
        )}
        <input
          value={value}
          type={type}
          className={classnames(classes.textInput)}
          id={id}
          onChange={onChange}
          placeholder={placeholder}
          {...inputProps}
        />
        {formError || formHelperText}
      </div>
    );
  }
}
/**
 * @property {string} label - Form label
 * @property {string} type - input type
 * @property {object} classes - css class string object
 * @property {string} id - input id
 * @property {function} onChange - Defined on change function callback
 * @property {object} inputProps - Button styling
 * @property {string} placeholder - input place holder string
 * @property {string} error - error message
 * @property {string} helperText - helper text string
 * @property {string} value - Input value
 */
TextField.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf(['tel', 'text', 'password', 'email']),
  classes: PropTypes.object,
  id: PropTypes.string,
  onChange: PropTypes.func,
  inputProps: PropTypes.object,
  placeholder: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  value: PropTypes.string,
  helperText: PropTypes.string,
};

/**
 * @property {string} label - default Form label
 * @property {string} type - default input id
 * @property {string} placeholder - idefault nput place holder string
 * @property {function} onChange - default  on change function callback
 * @property {object} classes - default css class string object
 */
TextField.defaultProps = {
  label: 'Text',
  type: 'text',
  placeholder: 'Tap here',
  onChange: () => {},
  classes: {
    formControl: 'form-group form-container',
    inputLabel: 'input-label',
    textInput: 'input-field',
    helperText: 'input-helper',
  },
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/common/TextField.js